import { combineReducers } from "redux";
import { title } from "./title";

/** Normalized structure to contain errors for notebook state. */
export const errors = combineReducers({
  title,
});
